import fetch from 'utils/fetch';

export function withdrawLogList( startTime,endTime,accountBegin,accountEnd,agent,productId,psize,currentPage) {
    const data = {
        startTime,
        endTime,
        accountBegin,
        accountEnd,
        productId,
        agent,
        psize,
        currentPage
    };
    return fetch({
        url: '/withdrawLogList',
        method: 'get',
        params : data
    });
}



// WEBPACK FOOTER //
// ./src/api/withdrawLog.js